import axios from "axios";
import {setStorage,getStorage,getAuthHeader} from '../config/Utils'
import { encode, base64 } from "base-64";

export const getUpayPaymentGatweay= async(body)=>{
  const url=`https://admin.allenoverseas.com/2023-2024/api/pay-u-money`
  return axios.post(url,body,getAuthHeader()).then((res)=>{
    return res.data
})
}



 
